import * as React from 'react';
import { Redirect } from 'react-router-dom';
import Modal from 'react-awesome-modal';
import { toast, ToastContainer } from 'react-toastify';

import withServices from '../../../../HOCs/withServices';
import NavBar from '../../../../components/CustomNav/CustomNav.Component';
import { Container, FormWrapper, Row, ContentWrapper, ContentBody, ContentHeading, InputWrapper, ModalContainer, FeedbackP, InputItemsRow } from '../../Common/Common.styles';
import DatePicker from '../../../../components/DatePicker/DatePickerComponent';

interface IProps {
    services?: any;
    history?: any;
}

interface IState {
    fname: string,
    lname: string;
    studentEmail: string,
    dob: string,
    navigate: boolean,
    destination: string,
    signupSuccess: boolean,
    feedbackOpen: boolean,
    dateObj: any;
}

class ChildRegistration extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      fname: "",
      lname: "",
      studentEmail: "",
      dob: "",
      navigate: false,
      destination: "",
      signupSuccess: false,
      feedbackOpen: false,
      dateObj: null,
    };
    this.onLogOut = this.onLogOut.bind(this);
    this.addChild = this.addChild.bind(this);
  }

  public async componentDidMount() {
    // add services
    const {
      services: { isUserLoggedIn },
    } = this.props;
    if (!isUserLoggedIn) {
      this.setState({ navigate: true, destination: "/login" });
    }
  }

  public onLogOut() {
    this.setState({ navigate: true, destination: "/login" });
  }

  public closeModal = (status) => {
    const {
      services: { currentBaseUrl },
    } = this.props;
    if (status === true) {
      // sign up was successful, go to login
      this.props.history.goBack();
    }
    this.setState({ feedbackOpen: false });
  };

  public handleChange = (field, e) => {
    console.log(field + e.target.value);
    if (field === "fname") {
      this.setState({ fname: e.target.value });
    }
    if (field === "lname") {
      this.setState({ lname: e.target.value });
    }
    // if (field === "dob") {
    //   this.setState({ dob: e.target.value });
    // }
    if (field === "email") {
      this.setState({ studentEmail: e.target.value });
    }
  };

  public ageChangeHandler = (dateObj) => {
    const dob = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, dob });
  };

  public async addChild(event) {
    event.preventDefault();
    const { fname, lname, studentEmail, dob } = this.state;
    const {
      services: { parentsAPI },
    } = this.props;
    const item = {
      first_name: fname,
      last_name: lname,
      email: studentEmail,
      dob,
    };
    const addChildRes = await parentsAPI.addChild(item);
    if (addChildRes.ok) {
      toast.success("Congratulations on adding your child");
      this.setState({ signupSuccess: true, feedbackOpen: true });
    } else {
      toast.error("Could not add a Learner to your subscription!");
      this.setState({ signupSuccess: false, feedbackOpen: true });
    }
  }
  public renderFeedbackModal = () => {
    const { feedbackOpen, signupSuccess } = this.state;
    if (feedbackOpen) {
      let content = (
        <FeedbackP success={signupSuccess}>
          <span>Child added Successfully! </span>
          <br /> Check their email for confirmation &amp; sign up deails!
        </FeedbackP>
      );
      if (!signupSuccess) {
        content = (
          <FeedbackP success={signupSuccess}>
            <span>Oooops, something went wrong! </span>
            <br /> check the details and try again!
          </FeedbackP>
        );
      }
      return (
        <Modal
          visible={feedbackOpen}
          effect="fadeInUp"
          onClickAway={this.closeModal.bind(this, signupSuccess)}
        >
          <ModalContainer>{content}</ModalContainer>
        </Modal>
      );
    } else {
      console.log("no feedback yet");
      return;
    }
  };

  public render() {
    if (this.state.navigate) {
      return <Redirect to={this.state.destination} />;
    }
    return (
      <Container>
        <ToastContainer />
        <NavBar logoutParent={this.onLogOut} />
        {this.renderFeedbackModal()}
        <Row>
          <ContentWrapper>
            <ContentHeading>
              GREAT JOB, YOU CAN ADD A CHILD TO YOUR PLAN
            </ContentHeading>
            <ContentBody>
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
              nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
              erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci
              tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo
              consequat. Duis autem vel eum iriure dolor in hendrerit in
              vulputate velit esse molestie consequat, vel illum dolore eu
              feugiat nulla facilisis at vero eros et accumsan et iusto odio
              dignissim qui blandit praesent luptatum zzril delenit augue duis
              dolore te feugait nulla facilisi. <br />
              Lorem ipsum dolor sit amet, cons ectetuer adipiscing elit, sed
              diam nonummy nibh euismod tincidunt ut laoreet dolore magna
              aliquam erat volutpat.
            </ContentBody>
          </ContentWrapper>

          <FormWrapper>
            <form onSubmit={this.addChild}>
              <InputWrapper>
                <p>1. What are your child's names?</p>
                <InputItemsRow>
                  <input
                    className="custom-textfield checkout-input"
                    type="text"
                    name="firstName"
                    id="first-name"
                    placeholder="First Name"
                    // onChange={this.handleChange}
                    required={true}
                    data-arg="firstName"
                    onChange={this.handleChange.bind(this, "fname")}
                  />

                  <input
                    className="custom-textfield checkout-input"
                    type="text"
                    name="lastName"
                    id="last-name"
                    placeholder="Last Name"
                    // onChange={this.handleChange}
                    required={true}
                    data-arg="lastName"
                    onChange={this.handleChange.bind(this, "lname")}
                  />
                </InputItemsRow>
              </InputWrapper>
              <InputWrapper>
                <p>2. What is your child's email address?</p>
                <input
                  type="text"
                  className="custom-textfield"
                  id="studentemail"
                  placeholder="Email Address"
                  required={true}
                  data-arg="studentemail"
                  onChange={this.handleChange.bind(this, "email")}
                />
              </InputWrapper>

              <InputWrapper>
                <p>3. How old is your child?</p>
                {/* <input
                  type="date"
                  name="dob"
                  id="dob"
                  className="custom-datepicker"
                  data-arg="dob"
                  required={true}
                  onChange={this.handleChange.bind(this, "dob")}
                /> */}
                <DatePicker
                  value={this.state.dateObj}
                  onChange={this.ageChangeHandler}
                />
              </InputWrapper>

              <button className="register-parent blue-button" type="submit">
                ADD
              </button>
            </form>
          </FormWrapper>
        </Row>
      </Container>
    );
  }
}
export default withServices(ChildRegistration);


// WEBPACK FOOTER //
// ./src/pages/Onboard/Parent/ChildRegistration/ChildRegistration.tsx